import { render, staticRenderFns } from "./IndividualBets.vue?vue&type=template&id=3f9a7911&scoped=true&"
import script from "./IndividualBets.vue?vue&type=script&lang=js&"
export * from "./IndividualBets.vue?vue&type=script&lang=js&"
import style0 from "./IndividualBets.vue?vue&type=style&index=0&id=3f9a7911&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9a7911",
  null
  
)

export default component.exports